module.exports = __webpack_public_path__ + "img/case28.01a0dddc.png";